import React from 'react'
import { Tooltip } from '@chegg-ui/tooltip'
import { sourceSearchTooltip } from '@chegg-wt/core/utils/searchSourcesMap'
import { connect } from 'react-redux'
import { ComponentPayload } from '@chegg-wt/core/state/instrumentation/rio/clickstreamComponentViews'
import { emitComponentViewEvent } from '@chegg-wt/core/state/instrumentation/actions'
import {
  SEARCH_BOTTOM,
  TooltipLocation,
  tooltipRioRegionMap,
  sourceRioOriginMap,
} from '@chegg-wt/core/utils/searchSources'
import { SourceType } from '@chegg-wt/core/types/core'
import {
  SOURCE_TOOLTIP_BODY,
  TOOLTIP_TARGET_SEARCH_BOTTOM,
  TOOLTIP_TARGET_SEARCH_RESULT,
} from '../CitationSearchInput/utils/testIds'
import * as Styled from './styled'

export interface SourceToolTipProps {
  sourceType: SourceType
  location: TooltipLocation
  emitComponentViewEvent: (payload: ComponentPayload) => void
}

const SourceToolTip: React.FC<SourceToolTipProps> = ({
  sourceType,
  location,
  emitComponentViewEvent,
}) => {
  if (!sourceSearchTooltip[sourceType?.id]) return null

  const handleTargetOver = () => {
    emitComponentViewEvent({
      origin: sourceRioOriginMap[sourceType?.id],
      region: tooltipRioRegionMap[location],
    })
  }

  return (
    <Tooltip
      position="bottom"
      targetElement={
        <Styled.TargetText
          onMouseOver={handleTargetOver}
          onFocus={handleTargetOver}
          data-test={
            location === SEARCH_BOTTOM
              ? TOOLTIP_TARGET_SEARCH_BOTTOM
              : TOOLTIP_TARGET_SEARCH_RESULT
          }
        >
          {sourceSearchTooltip[sourceType?.id][location]}
        </Styled.TargetText>
      }
      data-test={SOURCE_TOOLTIP_BODY}
    >
      <Styled.TooltipContent>
        {sourceSearchTooltip[sourceType?.id].tooltipBody}
      </Styled.TooltipContent>
    </Tooltip>
  )
}

const mapDispatchToProps = {
  emitComponentViewEvent,
}

export default connect(null, mapDispatchToProps)(SourceToolTip)
